<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:02:41
-->
<template>
  <div class="unPublish">
    <div class="list">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <businessItem
            @action="changeStatus"
            v-for="(item, index) in tableList"
            :key="index"
            :info="item"
          >
          </businessItem>
        </van-list>
      </van-pull-refresh>
      <div class="addBtn flex" @click="goAdd">
        <img src="../../../../assets/dispatch/new.png" />
        <span>新增计划</span>
      </div>
      <van-overlay :show="show" z-index="88">
        <div class="wrapper">
          <div class="block">
            <img
              src="../../../../assets/audit/x.png"
              class="icon"
              @click="onClickIcon"
            />
            <p class="title">是否发布</p>
            <van-field
              label-width="70"
              clickable
              name="picker"
              v-model="mmsi"
              label="海轮mmsi:"
              placeholder="请输入mmsi"
              input-align="right"
            />
            <van-field
              readonly
              clickable
              label-width="70"
              name="picker"
              :value="value.comp"
              label="选择客户:"
              placeholder="点击选择客户"
              @click="showPicker = true"
            />

            <van-field
              autocomplete="off"
              v-model="transitPort"
              name="中转港"
              label="中转港"
              placeholder="请填写中转港"
              readonly
              @click="showPi"
              :rules="[{ required: true, message: '请填写中转港' }]"
              right-icon="arrow-down"
            />
            <!-- 始发港 -->
            <van-field
              autocomplete="off"
              v-model="origin"
              name="picker"
              label="始发港"
              placeholder="请填写始发港"
              readonly
              @click="showPick('origin')"
              :rules="[{ required: true, message: '请填写始发港' }]"
              right-icon="arrow-down"
            />
            <!-- 目的港 -->
            <van-field
              autocomplete="off"
              v-model="liuxiang"
              name="picker"
              label="目的港"
              placeholder="请填写目的港"
              readonly
              @click="showPick('liuxiang')"
              :rules="[{ required: true, message: '请填写目的港' }]"
              right-icon="arrow-down"
            />
            <van-field
              autocomplete="off"
              v-model="currlist"
              name="picker"
              label="海轮离港日期:"
              label-width="90"
              placeholder="请选择海轮离港日期"
              readonly
              @click="planyue"
              :rules="[{ required: true, message: '请选择海轮离港日期' }]"
              right-icon="arrow-down"
            />

            <van-field
              readonly
              clickable
              label-width="110"
              name="picker"
              :value="datalise"
              label="长江口预抵时间:"
              placeholder="请选择时间"
              @click="uidata = true"
              class="fieldke"
            />
            <van-field name="是否场地货" label="是否场地货">
              <template #input>
                <van-radio-group v-model="cdType" direction="horizontal">
                  <van-radio :name="1">是</van-radio>
                  <van-radio :name="0">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <!-- 预计到达长江口时间 -->
            <van-popup v-model="uidata" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                title="请选择日期时间"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="onuidata"
                @cancel="uidata = false"
                :formatter="formatter1"
              />
            </van-popup>
            <!-- 客户 -->
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                value-key="comp"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>

            <!-- 选择月份 -->
            <van-popup
              v-model="pandata"
              position="bottom"
              :style="{ height: '30%' }"
            >
              <van-datetime-picker
                v-model="currentDate1"
                type="date"
                title="海轮离港日期"
                :min-date="minDate1"
                :max-date="maxDate1"
                @confirm="panlick"
                @cancel="canceldata"
              />
            </van-popup>
            <!-- 中转港 -->
            <van-popup
              v-model="transf"
              position="bottom"
              :style="{ height: '30%' }"
            >
              <van-picker
                show-toolbar
                title="选择中转港"
                visible-item-count="4"
                :columns="transferssList"
                @confirm="onConfirm1"
                value-key="name"
                @cancel="onCancel1"
              />
            </van-popup>
            <!-- 始发目的 -->
            <van-popup
              v-model="showUnit"
              position="bottom"
              :style="{ height: '30%' }"
            >
              <van-picker
                show-toolbar
                title="请选择"
                visible-item-count="4"
                :columns="portList"
                @confirm="onConfirmshi"
                value-key="label"
                @cancel="onCancel"
              />
            </van-popup>

            <div class="reject" @click="onClickState(1)">取消</div>
            <div class="pass" @click="onClickState(2)">发布</div>
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import {
  dispatchPlanList,
  dispatchReleasePlan,
  dispatchGetCustomer,
  transferss,
  dispatchGetPort,
} from "@/utils/network/interface";
import businessItem from "./item";
export default {
  name: "unPublish",
  components: {
    businessItem,
  },
  props: {
    keyWord: String,
  },
  data() {
    return {
      minDate: new Date(),
      maxDate: new Date(2040, 10, 1),
      currentDate: new Date(),
      //

      // 计划月份
      minDate1: new Date(2019, 0),
      maxDate1: new Date(2050, 12),
      currentDate1: new Date(this.formatter()),
      currlist: this.formatter(),
      // currlist: '',
      pandata: false,
      //
      name: "",
      mmsi: "",
      value: {},
      uidata: false,
      datalise: "",
      columns: [],
      showPicker: false,
      //
      tableList: [],
      currentRow: {},
      currentUnit: {},
      refreshing: false,
      loading: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      finished: false,
      show: false,
      transitPort: "", // 中转港
      transf: false, // 中转港
      transferssList: [], // 中转港
      cdType: "",
      origin: "", // 始发港
      liuxiang: "", // 目的港

      showUnit: false, // 始发港 目的港 公共
      portList: [], // 始发港 目的港 公共

      type: "origin",
    };
  },
  watch: {
    keyWord(newVal, oldVal) {
      this.pageInfo.pageNum = 1;
      this.tableList = [];
      this.onLoad();
    },
  },
  created() {},
  mounted() {
    this.getData();
    this.dispatchGetCustoFrom();
    this.transferssfrom();
    this.dispatchGetPort();
  },
  methods: {
    showPick(type) {
      this.type = type;
      this.$nextTick(() => {
        this.showUnit = true;
      });
    },
    // 中转港
    showPi() {
      this.transf = true;
    },
    onConfirm1(vale) {
      console.log(vale);
      this.transitPort = vale.name;
      this.transf = false;
    },
    onCancel1() {
      this.transf = false;
    },
    transferssfrom() {
      transferss().then((res) => {
        this.transferssList = res.data;
        //console.log(this.transferssList)
      });
    },
    // 始发
    onConfirmshi(value, index) {
      console.log(value[1], "shifa");
      if (this.type == "origin") {
        this.origin = value[1];
        this.showUnit = false;
        this.type = "";
      } else if (this.type == "liuxiang") {
        this.liuxiang = value[1];
        this.showUnit = false;
        this.type = "";
      }
    },
    onCancel() {
      this.type = "";
      this.showUnit = false;
    },
    dispatchGetPort() {
      dispatchGetPort().then((res) => {
        console.log(res);
        res.data.map((c) => {
          let obj = {
            label: c.label,
            children: c.options,
          };
          this.portList.push(obj);
        });
      });
    },
    //
    dispatchGetCustoFrom() {
      dispatchGetCustomer().then((e) => {
        // console.log(e.data,"d");
        this.columns = e.data;
      });
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    onuidata(va) {
      console.log(va, "10");
      var y = va.getFullYear();
      var m = va.getMonth() + 1;
      var d = va.getDate();
      var h = va.getHours();
      var m1 = va.getMinutes();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      m1 = m1 < 10 ? "0" + m1 : m1;
      let datali = y + "-" + m + "-" + d + " " + h + ":" + m1;
      console.log(datali, "44");
      this.datalise = datali;
      this.uidata = false;
    },
    formatter1(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      } else if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.tableList = [];
          this.refreshing = false;
        }
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { state: 0, pageSize, pageNum, bizName: this.keyWord };
        dispatchPlanList(obj)
          .then((res) => {
            console.log(res);
            if (res.code === 200) {
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 1000);
    },
    getData() {
      let obj = { state: 0, pageSize: 10, pageNum: 1, bizName: this.keyWord };
      dispatchPlanList(obj)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          if (res.code == 200) {
            this.tableList = res.rows;
            this.pageInfo.pageNum++;
            this.pageInfo.total = res.total;
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageInfo.pageNum = 1;
      this.getData();
    },
    changeStatus(data, methods) {
      console.log(data, "45");
      this.currentRow = data;
      this.mmsi = data.mmsi;
      this.cdType = data.cdType;
      this.value.comp = data.carrierComp;
      this.value.id = data.carrierId;
      this.datalise = data.yuCjkTime;
      this.transitPort = data.transitPort;
      this.origin = data.origin;
      this.liuxiang = data.liuXiang;
      this.currlist = data.planTime ? data.planTime : this.formatter();
      this.show = true;
    },
    goAdd() {
      this.$router.push({
        path: "/dispatch/business/add",
      });
    },
    onClickIcon() {
      this.show = false;
    },
    onClickState(type) {
      if (type == 1) {
        this.show = false;
        this.currlist = this.formatter();
        return;
      } else {
        if (!this.value.id) {
          this.$toast("选择客户");
        } else {
          if (!this.mmsi && this.cdType == 0) {
            this.$toast("请输入mmsi");
          } else {
            dispatchReleasePlan({
              id: this.currentRow.id,
              carrierId: this.value.id,
              mmsi: this.mmsi,
              yuCjkTime: this.datalise,
              planTime: this.currlist,
              transitPort: this.transitPort,
              origin: this.origin,
              liuxiang: this.liuxiang,
              cdType: this.cdType,
            }).then((res) => {
              if (res.code == 200) {
                this.$toast("发布成功");
                this.value = {};
                this.show = false;
                this.pageInfo.pageNum = 1;
                this.onRefresh();
              }
            });
          }
        }
      }
    },
    // 计划月份
    // 计划月份
    planyue() {
      this.pandata = true;
    },
    panlick(time) {
      console.log(time);
      this.currlist = this.formatter(time);
      this.pandata = false;
    },
    canceldata() {
      this.pandata = false;
    },
    formatter(time) {
      let nowdata = time == null ? new Date() : new Date(time);
      let year = nowdata.getFullYear();
      let month = nowdata.getMonth() + 1;
      let date = nowdata.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month + "-";
      if (date < 10) {
        nowtime += "0";
      }
      nowtime += date;

      return nowtime;
    },
  },
};
</script>

<style lang="less" scoped>
.unPublish {
  .addBtn {
    position: fixed;
    right: 0;
    bottom: 100px;
    width: 115px;
    height: 34px;
    background: rgba(68, 177, 249, 0.5);
    border-radius: 37px 0 0 37px;
    color: #024e80;
    font-size: 12px;
    padding: 6px;
    align-content: center;
    align-items: center;

    img {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 9999999;

    .block {
      width: 290px;
      // height: 260px;
      padding-bottom: 15px;
      background: url("../../../../assets/icon/layoutBg.png") 0 0 no-repeat #fff;
      background-size: 290px 61px;
      border-radius: 10px;
      position: relative;

      .icon {
        width: 11px;
        height: 11px;
        float: right;
        right: 16px;
        top: 25px;
        position: absolute;
      }

      .fieldke {
        margin-bottom: 10px;
      }

      /deep/.van-field__label {
        margin-right: 2px;
      }

      .title {
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        text-align: center;
        margin: 26px 0 10px;
        // margin-bottom: 55px;
        line-height: 1;
      }

      .reject {
        width: 87px;
        height: 28px;
        border: 1px solid #f7b346;
        border-radius: 5px;
        color: #f7b346;
        text-align: center;
        line-height: 28px;
        float: left;
        margin-left: 40px;
      }

      .pass {
        width: 87px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        float: left;
        margin-left: 20px;
      }
    }
  }
}
</style>